import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Head from 'next/head';
import NotFound from './NotFound';
import Logo from '../logo';
import Background from './Background';
import styles from './Page404.module.scss';

const Page404 = () => {
  const [href, setHref] = useState<string | null>(null)
  useEffect(() => {
    setHref(`${window.location.origin}/create`);
  }, []);

  return (
    <div className={styles.container}>
      <Head>
        <title>404 Nothing to see here | DownmixIt!</title>
      </Head>
      <Background />
      <div className={styles.content}>
        <div className={styles.notFound}>
          <NotFound />
          <NotFound />
        </div>
        <footer>
          NOTHING TO SEE HERE.
        </footer>
      </div>
      <header>
          <Logo data-theme="dark" />
          {
            href && (
            <Link href="/">
              Home
            </Link>
            )
          }
      </header>
    </div>
  );
}

export default Page404;
